<template>
  <div class="container">
    <div class="content">
      <h2>👶 Little Explorers 🚼</h2>
      <p><strong>🌟 Tiny Tots: Navigating the Adventure of Parenthood 🌟</strong></p>

      Welcome to the delightful chaos of raising little ones! Every child brings their own unique spark of joy, challenge, and unending curiosity. As we map out your financial journey, understanding your current or anticipated family dynamics can help us tailor our advice to suit your needs perfectly.

      <h3>The Dynamics of Your Den: Planning for the Pitter-Patter of Tiny Feet</h3>
        <div class="option" @click="selectOption('nokidshappy')" :class="{ selected: isSelected('nokidshappy') }">
          <span class="icon">🚫👶</span>
          <b>Child-free and Thriving: Enjoying the peace, quiet, and extra space for activities (or more cats, we don't judge).</b>
        </div>
        
        <div class="option" @click="selectOption('nokidswant')" :class="{ selected: isSelected('nokidswant') }">
          <span class="icon">👶❓</span>
          <b>Considering Parenthood: Thinking about adding more laughter (and a bit of chaos) to the household.</b>
        </div>
        
        <div class="option" @click="selectOption('onekid')" :class="{ selected: isSelected('onekid') }">
          <span class="icon">1️⃣👶</span>
          <b>One Little Wonder: Navigating the world with a mini-me in tow.</b>
        </div>
        <div class="option" @click="selectOption('twoormore')" :class="{ selected: isSelected('twoormore') }">
          <span class="icon">👶👶</span>
          <b>A Bustling Household: Full hearts and hands with two or more.</b>
        </div>
    </div>
  </div><br><br><br>
</template>
  
  <script>
  import { onboardingStore } from '@/components/stores/onboardingStore'; 
  
  export default {
    setup() {
      const store = onboardingStore();
  
      const selectOption = (option) => {
        // Set the selected option directly
        store.updateFormData({ dependents: option });
      };
  
      // Helper method to check if an option is selected
      const isSelected = (option) => store.formData.dependents === option;
      
  
      return { store, selectOption, isSelected };
    },
  };
  </script>
<style scoped>
.container {
  background-color: #4A148C; 
 color: black;
 padding: 20px;
 border-radius: 20px;
 display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 300px;
  max-width: 800px; /* Set a maximum width */
  align-items: center; /* Centered alignment */
  margin: auto; /* Center the container on the page */
  margin-top: 0; /* Adjusted as per your requirement */
}

.content {
background-color: white;
padding: 20px;
border-radius: 10px;
color: black;
}

.option {
padding: 10px;
border: 1px solid #ccc;
border-radius: 10px;
text-align: center;
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
cursor: pointer;
transition: transform 0.3s ease, box-shadow 0.3s ease;
margin-bottom: 10px;
}

.option:hover {
transform: translateY(-5px);
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}


button {
  grid-column: span 2;
  background-color: #4A148C; /* Dark purple */
  color: white;
  padding: 10px 15px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s;
}

button:hover {
  background-color: black; /* Black background on hover */
}

.selected {
background-color: #4A148C; /* More solid color for selection */
color: white;
}


.icon {
font-size: 24px; /* Larger icon size */
}

/* Additional style if needed */
</style>